const GENDER_SELECT_OPTIONS = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
];

export default GENDER_SELECT_OPTIONS;
